<template>
  <div class="echarts1" ref="echarts1">

  </div>
</template>

<script>

import { FontChart } from '@/utils/utils'
import $ from 'jquery'
import Axios from "@/utils/Axios";
import qs from "qs";
export default {
  name: 'echarts1',
  components: {},
  props: {
    active: {
      type:  Number,
      default() {
        return '';
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.getpowdata(30)

  },
  computed: {
    colorList: function () {
      var list =
        [
        {
        start: '#2eeafc',
        end: '#024685'
      }, {
        start: '#fbc83f',
        end: '#917850'
      }, {
        start: '#e72d09',
        end: '#762036'
      },{
        start: '#25eafc',
        end: '#064685'
      }, {
        start: '#11c83f',
        end: '#aa7850'
      }, {
        start: '#552d09',
        end: '#798036'
      },{
        start: '#65eafc',
        end: '#0ff685'
      }, {
        start: '#00c83f',
        end: '#965850'
      }, {
        start: '#aa2d09',
        end: '#992036'
      },{
        start: '#11eafc',
        end: '#114685'
      }]
      var colorList = []
      list.forEach((type) => {
        var color = new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
          offset: 0,
          color: type.start
        },
          {
            offset: 1,
            color: type.end
          }
        ])
        colorList.push(color)
      });
      return colorList
    }
  },
  watch: {
    active(){
      let day
      if(this.active==1){
        day=7
      }else if(this.active==2){
        day=30
      }
      this.getpowdata(day)
    }
  },
  methods: {
    drawLine (newdata) {

      var that = this
      window.addEventListener('resize', this.drawLine)
      let myChart = this.$echarts.init(this.$refs.echarts1)
      var colors = this.colorList
      var data = newdata.monitorSiteProportions
      let arrdata=[]
      for(let i=0;i<data.length;i++){
        arrdata.push(data[i].monitorSiteDegree)
      }
      var option = {
        color: colors,
        // legend: {
        //   show: true,
        //   orient: 'vertical',
        //   bottom: 'center',
        //   right: '30',
        //   icon: 'circle',
        //   // itemGap: FontChart(20),
        //   // itemWidth: FontChart(10),
        //   // itemHeight: FontChart(10),
        //   width: '100%',
        //   textStyle: {
        //     color: 'rgba(4, 235, 250, 1)',
        //     // fontSize: FontChart(16)
        //   },
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{a} {b} : {c} ({d}%)'
        },

        grid: {
          right: '5%',
          bottom: '3%',
          left: '6%',
          top: '20px',
          containLabel: true
        },
        series: [
          {
            name: '能耗统计',
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['50%', '50%'],

            label: {
              show: true,
              normal: {
                position: 'outside',
                // fontSize: FontChart(14),
                color: 'rgba(4, 235, 250, 1)',
                formatter: (params) => {

                  return data[params.dataIndex].monitorSiteName + ' : ' + params.percent + '%'
                }
              }
            },
            labelLine: {
              length: 1,
              // length2: FontChart(20)
            },
            data: arrdata
          }
        ]
      }
      myChart.clear()
      myChart.resize()
      myChart.setOption(option)
    },
    getpowdata(day){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/monitorEnergyProportion"

      param.data=qs.stringify({
        day:day
      })
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0') {
         this.drawLine(res.data)
        }

      })
    },
  }
}
</script>

<style lang="scss" scoped>
.echarts1 {
  position: relative;
  width: 100%;
  height: calc(100% - 0px);
}
</style>
